export const ARTIST_LIST_TEST_ID = 'artist-list';
